import * as React from "react";

import "./order-details-sidebar.scss";

import {cs}            from "@Common/react/chain-services";
import {Link}          from "@Common/react/cst2";
import {keyed}         from "@Common/react/keyed";
import {Types}         from "@Common/types";
import {ModalService3} from "@Common/ui-components/modal-service-3/modal-service-3";

import {OrderDetailsSidebarContent} from "./order-details-sidebar-content";

type OrderDetails   = Types.Xpresso.Account.Orders.OrderDetailsSidebar.OrderDetails;
type FooterRenderer = (props:{close: () => void}) => React.ReactNode;

export const OrderDetailsSidebar = ({
    next: rootNext
}:{
    next: Link<React.ReactNode, Types.Common.UiComponents.ModalServiceSidebar.SidebarModalServiceNext<{
        orderDetails    : OrderDetails,
        renderFooter   ?: FooterRenderer,
    }>>,
}) => cs(
    ["", ({}) => ModalService3({
        sidebar: {},
        width: 500,
        // className   : "order-details-sidebar-u3e-modal",
        xdQaName: "Order Details Sidebar",
        next: ({params: {orderDetails, renderFooter}, close}) => (
            <div className="order-details-sidebar-56z">
                {OrderDetailsSidebarContent({orderDetails})}

                {renderFooter?.({close})}
            </div>
        ),
        rootNext,
    })],
);

// Display a list of orders
export const OrderDetailsSidebar2 = ({next: rootNext}) => ModalService3<any>({
    sidebar: {},
    width: 500,
    // className   : "order-details-sidebar-u3e-modal",
    xdQaName: "Order Details Sidebar",
    next: ({params: {orderList, renderFooter}, close}) => (
        <div className="order-details-sidebar-56z">
            {orderList.map((orderDetails, i) => cs(
                keyed(i),
                () => OrderDetailsSidebarContent({orderDetails})
            ))}

            {renderFooter?.({close})}
        </div>
    ),
    rootNext,
});

